import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Toolbar from '@mui/material/Toolbar';
import { Menu } from 'lucide-react';
import { LAYOUT } from '@/theme';
import { Brand } from './Brand';

/** Phones only: the menu button and the brand. On wider screens the sidebar is always there and says where you are. */
export function TopBar({ onMenuClick }: { onMenuClick: () => void }) {
  return (
    <AppBar position="sticky" sx={{ ...appBarSx, display: { md: 'none' } }}>
      <Toolbar sx={{ gap: 1.5, minHeight: { xs: LAYOUT.topBarHeight, sm: LAYOUT.topBarHeight }, px: { xs: 2, md: 4 } }}>
        <Link href="#main-content" sx={visuallyHiddenUntilFocused}>
          Skip to content
        </Link>
        <IconButton edge="start" aria-label="Open navigation" onClick={onMenuClick}>
          <Menu size={20} strokeWidth={1.75} />
        </IconButton>
        <Box sx={{ display: 'flex', mr: 'auto', minWidth: 0 }}>
          <Brand compact />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

const appBarSx = {
  top: 0,
  bgcolor: 'color-mix(in srgb, var(--mui-palette-background-paper) 88%, transparent)',
  backdropFilter: 'saturate(180%) blur(8px)',
  borderBottom: 1,
  borderColor: 'divider',
} as const;

const visuallyHiddenUntilFocused = {
  position: 'absolute',
  left: -9999,
  '&:focus': { left: 16, top: 12, zIndex: 1, bgcolor: 'background.paper', px: 1 },
} as const;
